module.exports = __webpack_public_path__ + "img/campaignImage1.2bdde529.png";